import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { useZed } from '@modules/core/src/react/useZed';
import { StandardModule } from '@modules/standard/src/StandardModule';
import { useEffect, useState } from 'react';

import { GisComplexGuiResponse } from '../ecs/component/response/GisComplex';
import { TourDanjiModule } from '../TourDanjiModule';

import { getItemStyle, GUIView, preUpdateGUI } from './GUIUtiles';
import style from './styles/DongPanel.module.css';

export function GisComplexPanel() {
  const zed = useZed<[BabylonjsModule, StandardModule, TourDanjiModule]>();
  const [gisGUIs, setGisGUIs] = useState<GisComplexGuiResponse[]>([]);

  useEffect(() => {
    if (!zed) return;

    const observer = zed.api.observer.onUpdateGisComplexGUI.add((data) => {
      setGisGUIs(JSON.parse(JSON.stringify(data)));
      data.map((item) => {
        preUpdateGUI(document.getElementById(`${item.object.id}`), item);
      });
    });
    return () => {
      observer?.remove();
    };
  }, [zed]);

  function renderDongItem(item: GisComplexGuiResponse) {
    if (!item.isVisible) return null;
    return (
      <div
        key={item.key}
        id={`${item.object.id}`}
        style={getItemStyle({
          x: item.x,
          y: item.y,
          scaleWithCameraDistance: item.iconScaleOffset,
          zIndex: item.zIndex,
        })}>
        <div className={style.container}>
          <div className={style.simpleDongPanel}>
            <div
              className={style.simpleDongTitle}
              style={{
                opacity: 0.5,
              }}>
              <span className={style.dongNumber}>{item.object.name}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <GUIView>{gisGUIs.map((item) => renderDongItem(item))}</GUIView>;
}
